module.exports = __webpack_public_path__ + "media/img/patterns/pattern-1-4f8f99efb00cab5b752ab4d996d9876d.svg";